<template>
  <div class="recommendation__price">
    <span
      id="container__product-price"
      class="product-price"
      :class="{ 'product-price--sale': oldPrice }"
    >
      <span v-if="oldPrice" class="product-price__previous">{{
        formattedOldPrice
      }}</span>
      <span class="product-price__current price selling">{{
        formattedPrice
      }}</span>
    </span>
  </div>
</template>

<script>
import priceable from '~/mixins/priceable'

export default {
  name: 'RecommendationPrice',
  mixins: [priceable],
  props: {
    oldPrice: {
      type: String,
    },
    price: {
      type: String,
      required: true,
    },
  },
  computed: {
    formattedOldPrice() {
      return this.formatPrice(this.oldPrice)
    },
    formattedPrice() {
      return this.formatPrice(this.price)
    },
  },
}
</script>
<style lang="scss" scoped>
.recommendation__price {
  user-select: none;
}
</style>
